import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../college-theme.css';

const SCHOOL_MODULES = [
  { name: 'Dashboard', meta: 'as-is' },
  { name: 'Projects', meta: 'EE · IA · TOK' },
  { name: 'Planner', meta: 'shared' },
  { name: 'Recall', meta: 'as-is' },
  { name: 'Research', meta: 'as-is' },
];

const COLLEGE_MODULES = [
  { name: 'Overview', meta: 'globe + countdown' },
  { name: 'My List', meta: 'plans + deadlines' },
  { name: 'Browse', meta: 'US News ranked' },
  { name: 'Visits', meta: 'shared' },
  { name: 'Essays', meta: 'brainstorm + tasks' },
  { name: 'SAT Prep', meta: 'shared' },
  { name: 'Docs', meta: 'Drive-linked' },
  { name: 'Access', meta: 'parents + advisor' },
  { name: 'Profile', meta: 'your numbers' },
];

export default function HubPage() {
  const navigate = useNavigate();
  const { api } = useAuth();
  const [ticker, setTicker] = useState('');

  useEffect(() => {
    let alive = true;
    api.get('/college-applications')
      .then((res) => {
        if (!alive) return;
        const apps = res.data.applications || [];
        if (!apps.length) { setTicker('No schools on your list yet'); return; }
        const next = apps[0];
        setTicker(`${apps.length} school${apps.length === 1 ? '' : 's'} · ${next.collegeName} ${next.plan} in ${next.days}d`);
      })
      .catch(() => setTicker(''));
    return () => { alive = false; };
  }, [api]);

  const todayLabel = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ECE7DB', color: '#16130D', fontFamily: "'Instrument Sans', sans-serif" }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 40px', borderBottom: '1px solid #DAD3C2' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontFamily: "'IBM Plex Sans', sans-serif" }}>
          <div style={{ width: 14, height: 14, background: '#C81E1E' }} />
          <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Coursework</span>
        </div>
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: '#7A7264' }}>{todayLabel}</span>
      </div>

      <div style={{ flex: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24, padding: '32px 40px' }} className="hub-cards">
        {/* School card */}
        <div
          onClick={() => navigate('/dashboard')}
          style={{
            background: '#FFFFFF', border: '1px solid #DAD3C2', borderTop: '4px solid #C81E1E',
            padding: 40, display: 'flex', flexDirection: 'column', cursor: 'pointer',
            fontFamily: "'IBM Plex Sans', sans-serif",
          }}
        >
          <p style={{ margin: 0, fontSize: 10, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8A8375' }}>
            Section 01 — Unchanged
          </p>
          <h2 style={{ margin: '14px 0 8px', fontSize: 52, fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1 }}>School</h2>
          <p style={{ margin: '0 0 28px', fontSize: 14, color: '#6E6858', maxWidth: '44ch' }}>
            The IB academics workspace you use today — Swiss grid, IBM Plex, red. Nothing moves.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {SCHOOL_MODULES.map((m) => (
              <div
                key={m.name}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '12px 12px', borderLeft: '2px solid transparent', borderBottom: '1px solid #EFEBE1',
                  fontSize: 14, color: '#4A453B',
                }}
              >
                <span>{m.name}</span>
                <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: '#A39B89' }}>{m.meta}</span>
              </div>
            ))}
          </div>
          <p style={{ margin: '24px 0 0', fontSize: 10, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#B3AB99' }}>
            IBM Plex · Swiss UI
          </p>
        </div>

        {/* College card */}
        <div
          onClick={() => navigate('/college')}
          style={{
            background: '#16130D', color: '#F1E9D8', padding: 40,
            display: 'flex', flexDirection: 'column', cursor: 'pointer',
          }}
        >
          <p style={{ margin: 0, fontSize: 10, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8F8570' }}>
            Section 02 — Overhauled
          </p>
          <h2 style={{ margin: '10px 0 8px', fontFamily: "'Instrument Serif', Georgia, serif", fontStyle: 'italic', fontWeight: 400, fontSize: 64, lineHeight: 1 }}>
            College
          </h2>
          <p style={{ margin: '0 0 28px', fontSize: 14, color: '#B5AC97', maxWidth: '44ch' }}>
            The application desk. Your list, your numbers, one globe, every deadline counted down.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            {COLLEGE_MODULES.map((m) => (
              <div
                key={m.name}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '12px 12px', borderBottom: '1px solid #2A251B', fontSize: 14, color: '#CFC5AE',
                }}
              >
                <span style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontSize: 17 }}>{m.name}</span>
                <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: '#7C7360' }}>{m.meta}</span>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 24 }}>
            <p style={{ margin: 0, fontSize: 10, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#6F6552' }}>
              Editorial UI
            </p>
            <p style={{ margin: 0, fontFamily: "'IBM Plex Mono', monospace", fontSize: 12, color: '#D8A94C' }}>{ticker}</p>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '16px 40px', borderTop: '1px solid #DAD3C2', fontFamily: "'IBM Plex Sans', sans-serif" }}>
        <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#8A8375' }}>
          Shared across both
        </span>
        <span
          onClick={() => navigate('/planner')}
          style={{ fontSize: 12, border: '1px solid #C9C1AE', padding: '4px 12px', borderRadius: 999, color: '#4A453B', cursor: 'pointer' }}
        >
          Planner
        </span>
        <span
          onClick={() => navigate('/deadlines')}
          style={{ fontSize: 12, border: '1px solid #C9C1AE', padding: '4px 12px', borderRadius: 999, color: '#4A453B', cursor: 'pointer' }}
        >
          Deadlines
        </span>
      </div>
    </div>
  );
}
